import { __awaiter, __extends, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateAppMessageResult, defaultSdkError, formulateAppMessageResult, formulateSdkResponse, logMessageResult, onSdkError, } from './messageHandlingUtils';
/**
 * Responsible for media capability and its related message requests.
 */
var MediaMessageHandler = /** @class */ (function (_super) {
    __extends(MediaMessageHandler, _super);
    function MediaMessageHandler(appSdkHost, mediaService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.mediaService = mediaService;
        return _this;
    }
    MediaMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.media.selectMedia, function (_, params) { return formulateSdkResponse(params, _this.mediaService.selectMedia); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.media.selectMedia, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.media.captureImage, function (_) { return formulateSdkResponse(captureImageProps, _this.mediaService.selectMedia); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.media.selectMedia, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.media.getMedia, function (messageEvent, param) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mediaService.getMedia(param, function (mediaResult) {
                            return _this.postMediaResult(messageEvent.data, mediaResult);
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, logMessageResult];
                }
            });
        }); }, { errorCallback: this.onGetMediaError });
        this.registerHandler(SdkMessageTypes.media.viewImages, function (_, params) { return callServiceAndFormulateAppMessageResult(_this.mediaService.viewImages, params); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.media.viewImages, error, scenario); },
        });
    };
    MediaMessageHandler.prototype.validateDependencies = function () {
        if (!this.mediaService) {
            throw 'No mediaService provided';
        }
    };
    MediaMessageHandler.prototype.onGetMediaError = function (error, scenario) {
        scenario === null || scenario === void 0 ? void 0 : scenario.fail("GetMedia failed ".concat(error));
        var data = {
            error: defaultSdkError,
        };
        return formulateAppMessageResult(data);
    };
    MediaMessageHandler.prototype.postMediaResult = function (messageRequest, mediaResult) {
        if (mediaResult.mediaChunk) {
            if (mediaResult.mediaChunk.chunkSequence > 0) {
                this.appSdkHost.postResponseToApp(messageRequest.id, [mediaResult], true);
            }
            else {
                this.appSdkHost.postResponseToApp(messageRequest.id, [mediaResult], false);
            }
            return Promise.resolve();
        }
        else {
            return Promise.reject('empty media chunk');
        }
    };
    return MediaMessageHandler;
}(BaseMessageHandler));
export { MediaMessageHandler };
var captureImageProps = {
    mediaType: 1,
    maxMediaCount: 1,
    imageProps: {
        sources: [1, 2],
        startMode: 1,
        ink: true,
        cameraSwitcher: true,
        textSticker: true,
        enableFilter: false,
    },
};
//# sourceMappingURL=media-message-handler.js.map